import { DataProvider, useCurrentUser } from '@qualio/ui-components';

import { useSearchParams } from 'react-router-dom';
import { ExportDocumentListButton } from '../Export/ExportDocumentListButton/ExportDocumentListButton';

export const ExportButton = () => {
  const currentUser = useCurrentUser();
  const [searchParams] = useSearchParams();
  const { data, isLoading } = DataProvider.useDataProvider();
  const tagsParams = searchParams.getAll('filteringTag');
  const orderParam = searchParams.get('order_by');
  const selectedTags = tagsParams ?? [];
  const searchQuery = searchParams.get('query');
  const templatesParam = searchParams.getAll('filteringTemplates');
  return (
    <ExportDocumentListButton
      currentUser={currentUser}
      tagsFilter={selectedTags}
      isDisabled={isLoading || !data || data.length === 0}
      searchQuery={searchQuery}
      sortingValue={orderParam}
      templatesFilter={templatesParam}
    />
  );
};
